import { Icon, IconProps } from "@chakra-ui/react";
import { useId } from "react";

export default function CaminoAnnounce(props: IconProps) {
  const clipPathId = useId();
  return (
    <Icon
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <g clipPath={`url(#${clipPathId})`}>
        <path
          d="M13.1929 3.5837L13.342 12.3989M13.3348 11.9361L2.60657 8.86949L2.58564 7.47762L13.2031 4.04814"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.0854 9.53648L4.10602 10.7334C4.11536 11.1641 4.29542 11.5735 4.60658 11.8714C4.76066 12.019 4.94228 12.1347 5.14108 12.212C5.33988 12.2894 5.55196 12.3268 5.76523 12.3222C5.97849 12.3175 6.18875 12.271 6.38401 12.1851C6.57927 12.0992 6.7557 11.9757 6.90323 11.8216C7.05076 11.6675 7.16649 11.4859 7.24383 11.2871C7.32117 11.0883 7.35859 10.8762 7.35396 10.663L7.35044 10.4715"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </Icon>
  );
}
